// src/views/orders/Create/OrderDetailsSection.jsx
import React from 'react'
import { CFormSelect } from '@coreui/react'

const OrderDetailsSection = ({
  inputList,
  orderType,
  subOrderType,
  orderDeliveryZone,
  skuLocation,
  agents,
  machines,
  crops,
  operator,
  priceLoaded,
  errorList,
  onFieldChange,
  onXeroFieldChange,
  onAddOperator,
  onRemoveOperator,
  onOperatorChange,
}) => {
  return (
    <>
      <h5>Order Information</h5>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <label className="pb-2">Created By</label>
          <input
            type="text"
            name="user_name"
            className="form-control"
            value={inputList.user_name}
            disabled
          />
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">
            Order Type <span className="text-danger">*</span>
          </label>
          <CFormSelect
            name="order_type"
            value={inputList.order_type}
            onChange={onXeroFieldChange}
            disabled={priceLoaded}
          >
            <option value="">-- select --</option>
            {orderType.map((ot) => (
              <option key={ot.id} value={ot.id}>
                {ot.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['order_type']}</span>
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">Sub Order Type</label>
          <CFormSelect
            name="sub_order_type"
            value={inputList.sub_order_type}
            onChange={onFieldChange}
          >
            <option value="">-- select --</option>
            {subOrderType.map((st) => (
              <option key={st.id} value={st.id}>
                {st.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['sub_order_type']}</span>
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">
            Order Delivery Zone <span className="text-danger">*</span>
          </label>
          <CFormSelect
            name="order_delivery_zone"
            value={inputList.order_delivery_zone}
            onChange={onXeroFieldChange}
            disabled={priceLoaded}
          >
            <option value="">-- select --</option>
            {orderDeliveryZone.map((dz) => (
              <option key={dz.id} value={dz.id}>
                {dz.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['order_delivery_zone']}</span>
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">SKU Location</label>
          <CFormSelect
            name="sku_location"
            value={inputList.sku_location}
            onChange={onXeroFieldChange}
            disabled={priceLoaded}
          >
            <option value="">-- select --</option>
            {skuLocation.map((sl) => (
              <option key={sl.id} value={sl.id}>
                {sl.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['sku_location']}</span>
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">Agent</label>
          <CFormSelect name="agent_id" value={inputList.agent_id} onChange={onFieldChange}>
            <option value="">-- select --</option>
            {agents.map((ag) => (
              <option key={ag.id} value={ag.id}>
                {ag.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['agent_id']}</span>
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">Machine</label>
          <CFormSelect
            name="machine_id"
            value={inputList.machine_id}
            onChange={onXeroFieldChange}
            disabled={priceLoaded}
          >
            <option value="">-- select --</option>
            {machines.map((mc) => (
              <option key={mc.id} value={mc.id}>
                {mc.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['machine_id']}</span>
        </div>

        <div className="col-lg-4 mb-3">
          <label className="pb-2">Crop</label>
          <CFormSelect name="crop_id" value={inputList.crop_id} onChange={onFieldChange}>
            <option value="">-- select --</option>
            {crops.map((cp) => (
              <option key={cp.id} value={cp.id}>
                {cp.name}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['crop_id']}</span>
        </div>

        <div className="col-lg-6 mb-3">
          <label className="pb-2">Operators</label>
          {inputList.operators.map((op, idx) => (
            <div className="d-flex align-items-center mb-2" key={idx}>
              <CFormSelect
                name="operators_id"
                value={op.operators_id}
                onChange={(e) => onOperatorChange(e, idx, 'operators')}
              >
                <option value="">-- select --</option>
                {operator.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.fname} {o.lname}
                  </option>
                ))}
              </CFormSelect>

              {inputList.operators.length - 1 === idx && (
                <button
                  className="btn btn-success ms-2"
                  onClick={onAddOperator}
                  disabled={priceLoaded}
                >
                  Add
                </button>
              )}
              {inputList.operators.length > 1 && (
                <button className="btn btn-danger ms-2" onClick={(e) => onRemoveOperator(e, idx)}>
                  Remove
                </button>
              )}
            </div>
          ))}
          <span className="text-danger">{errorList['operators']}</span>
        </div>

        <div className="col-lg-12 mb-3">
          <label className="pb-2">Order Note</label>
          <input
            type="text"
            name="order_note"
            className="form-control"
            value={inputList.order_note}
            onChange={onFieldChange}
          />
          <span className="text-danger">{errorList['order_note']}</span>
        </div>
      </div>
    </>
  )
}

export default OrderDetailsSection
